import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class DividasEmAbertoApi extends Api {
  async consultarDividasEmAberto (filter) {
    try {
      const urlConsultarDividasEmAberto = resolve('urlConsultarDividasEmAberto');
      const response = await this.fetch(urlConsultarDividasEmAberto, 'POST', filter, { 'content-type': 'application/json' });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

    async consultarNomes () {
    try {
      const nomesUrl = resolve('urlConsultarDividasEmAbertoBeneficiarios');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDividasEmAbertoBoolean () {
    try {
      const urlConsultarDividasEmAbertoBoolean = resolve('urlConsultarDividasEmAbertoBoolean');
      const response = await this.fetch(urlConsultarDividasEmAbertoBoolean);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDividasEmAbertoRelatorio (filter) {
    try {
      const urlConsultarDividasEmAbertoRelatorio = resolve('urlConsultarDividasEmAbertoRelatorio');
      const response = await this.fetch(urlConsultarDividasEmAbertoRelatorio, 'POST', filter, { 'content-type': 'application/json' });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDividaPorCarteira (carteira) {
    try {
      const urlConsultarDividaPorCarteira = resolve('urlConsultarDividaPorCarteira') + carteira;
      const response = await this.fetch(urlConsultarDividaPorCarteira);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async getSituacao (codServidor) {
    try {
      const urlConsultarSituacaoServidor = resolve('urlConsultarSituacaoServidor') + codServidor;
      const response = await this.fetch(urlConsultarSituacaoServidor);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDividasEmAbertoDataTable (filter) {
    let dividasEmAberto = [];
    let result = await this.consultarDividasEmAberto(filter);
    result.map(res => {
      const { beneficiario, situacaoAtual, saldoAnteriorDivida, valorDividaMes, valorPagamentoMes, perdasPorFalecimento, perdasPorPequenoValor, dividaEmAberto, txtObservacao } = res;
      dividasEmAberto.push(Object.values({ beneficiario, situacaoAtual, saldoAnteriorDivida, valorDividaMes, valorPagamentoMes, perdasPorFalecimento, perdasPorPequenoValor, dividaEmAberto, txtObservacao }));
    });
    return dividasEmAberto;
  }

  async carregar (filter) {
    try {
      const urlCarregarDividasEmAberto = resolve('urlCarregarDividasEmAberto');
      const response = await this.fetch(urlCarregarDividasEmAberto, 'POST', filter, { 'content-type': 'application/json' });
      return response.data;
    } catch (error) {
      console.error(error);
    }

  }
}

export default DividasEmAbertoApi;
